import { AppDataSource } from "global/DataSources/AppDataSource";
import {
    applyVisibility, BuildVisibilityScope
} from "global/Visibility/GlobalVisibility";
import { IVisibilityScope } from "global/Visibility/IVisibilityScope.type";
import { IGroupConfigurationConfig, IGroupConfigurationData } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

export class VisibilityTransformer extends BaseJsonTransformer {
    config: IGroupConfigurationConfig;
    dataSource: AppDataSource;

    readonly container = {
        json: null as (null | IGroupConfigurationData),
        scope: null as (null | IVisibilityScope)
    };

    constructor(config: IGroupConfigurationConfig, dataSource: AppDataSource) {
        super();
        this.config = config;
        this.dataSource = dataSource;
    }

    async before(json: IGroupConfigurationData): Promise<void> {
        console.log("[tran] VisibilityTransformer.before")

        this.container.json = json;
        this.container.scope = BuildVisibilityScope(null, json, null, null);
    }

    // async transformGroupConfiguration(json: IGroupConfigurationData, snapshot: IXrmTypes.bcbs_groupconfigurationsnapshot): Promise<void> {
    //     applyVisibility(json, this.config);
    // }

    async after(json: IGroupConfigurationData): Promise<void> {
        applyVisibility(json, this.config);
    }

}